module.exports = __webpack_public_path__ + "static/img/qingqu1.f4b7339.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img1/qqly/qingqu1.jpg
// module id = swVe
// module chunks = 0